import { COMPETITORS_ORDER } from 'app/config/competitors.config';

import type { MonitoringFilterState, MonitoringFilterAction } from './types';

const initialState: MonitoringFilterState = {
  filters: {
    comparingWith: COMPETITORS_ORDER.filter(name => !name.includes('pandaodds')),
    markets: [],
    scoreThreshold: 0,
    showHidden: false,
    selectedTournaments: { videogames: [] },
    outsideOfMarket: false
  }
};

function reducer(
  state: MonitoringFilterState,
  action: MonitoringFilterAction
): MonitoringFilterState {
  switch (action.type) {
    case 'UPDATE_FILTER':
      return {
        ...state,
        filters: action.payload
      };
    default:
      return state;
  }
}

export { initialState, reducer };
